import React from "react";
import AudioPlayer from "./audioPlayer/AudioPlayer";
import "./audioPlayer/AudioPlayer.css";

export default function Audio(props) {
  if (!props.src) {
    return null;
  }

  return (
    <div style={{backgroundColor: "black"}}>
    <div className={props.isMobile ? "mobile-container" : "desktop-container"}>
      <div className="container-audio">
        <AudioPlayer audioSrc={props.src} />
      </div>
    </div>
    </div>
  );
}